
import { defuFn } from '/home/vsts/work/1/s/src/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default /* #__PURE__ */ defuFn(inlineConfig)
